import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ToastComponent } from "../components/toast-component/toast.component";

@Injectable({ providedIn: "root" })
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  show(
    message: string,
    type: "success" | "error" | "info" | "warning" = "info",
    position: MatSnackBarConfig["verticalPosition"] = "top",
    anchor?: HTMLElement
  ) {
    const iconMap: Record<typeof type, string> = {
      success: "check_circle",
      error: "error",
      info: "info",
      warning: "warning",
    };
    const cssMap: Record<typeof type, string> = {
      success: "toast-success",
      error: "toast-error",
      info: "toast-info",
      warning: "toast-warning",
    };
    const config: MatSnackBarConfig = {
      duration: 5000,
      data: { message, type, icon: iconMap[type], panelCss: cssMap[type] },
      horizontalPosition: "right",
      verticalPosition: position,
      panelClass: [cssMap[type]],
    };

    // Attach to a specific element (optional)
    if (anchor) {
      config.announcementMessage = ""; // accessibility fix
      (config as any).anchor = anchor;
    }

    this.snackBar.openFromComponent(ToastComponent, config);
  }

  success(message: string, anchor?: HTMLElement) {
    this.show(message, "success", "top", anchor);
  }

  error(message: string, anchor?: HTMLElement) {
    this.show(message, "error", "bottom", anchor);
  }

  info(message: string, anchor?: HTMLElement) {
    this.show(message, "info", "bottom", anchor);
  }

  warning(message: string, anchor?: HTMLElement) {
    this.show(message, "warning", "bottom", anchor);
  }
}
